module.exports = __webpack_public_path__ + "img/BWA.4a9534bb.svg";